import { KeyValue } from '@angular/common';
import {
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { BaseComponent } from '@app/shared/base/base-component/base-component.component';
import { PageHeaderComponentModel } from '@app/shared/interfaces/page-header-component-model';
import { CommonService } from '@product/shared/services/common.service';

@Component({
  selector: 'app-product-status',
  templateUrl: './product-status.component.html',
  styleUrls: ['./product-status.component.less'],
})
export class ProductStatusComponent implements OnInit {
  @Input() formGroup: FormGroup;
  @Input() mode: string;
  @Output() submitChanges: EventEmitter<any> = new EventEmitter();
  record: any;

  rolesOptions: { id: string; name: string }[] = [];
  constructor(private commonService: CommonService) {}

  ngOnInit(): void {
    // this.rolesOptions
    this.commonService.getRoles().subscribe((response) => {
      this.rolesOptions = response;
    });
  }

  submit() {
    this.submitChanges.emit();
  }

  recordLoaded(record: any) {
    this.record = record;
    this.formGroup.get('RolesToEditProduct')?.setValue(this.record.RolesToEditProduct.split(';'));
  }

  cleanRecord(record: any) : any{
    return record;
  }

  beforeSubmit() {
    const ids = this.formGroup.get('RolesToEditProduct')?.value as string[];
    if(ids != null && ids.toString() !== ''){
      this.formGroup.controls['RolesToEditProduct'].setValue(ids.join(';'));
    }
  }

  static controls(mode: string) {
    const controlsToReturn: any = {};
    if (mode === 'edit') {
      controlsToReturn['Id'] = [null, []];
    }

    controlsToReturn['Name'] = [null, [Validators.required]];
    controlsToReturn['IsDefault'] = [null, [Validators.required]];
    controlsToReturn['RolesToEditProduct'] = [null, [Validators.required]];
    return controlsToReturn;
  }
}
